import { t } from 'i18next'

import OffsiteAdvertiserReviewTable from '~/modules/retailMedia/components/_tables/OffsiteAdvertiserReviewTable'
import CampaignsPageHeader from '~/modules/retailMedia/components/CampaignsPageHeader'
import FilterCampaignStatus from '~/modules/retailMedia/components/Filters/FilterCampaignStatus'
import MainTabs from '~/modules/retailMedia/components/MainTabs'
import { useAllowOffsiteBriefingCampaign } from '~/modules/retailMedia/hooks/useAllowOffsiteBriefingCampaign'

import { offsiteAdvertiserReviewStatusFilterOptions } from './statusFilterOptions'

const OffsiteAdvertiserReviewList = () => {
  // Header e fila precisam falar do mesmo publisher: em white label o gate
  // resolve pelo token, não pelo `rmid` da URL.
  const { publisherId } = useAllowOffsiteBriefingCampaign()

  return (
    <>
      <CampaignsPageHeader
        section={t('rm:offsiteAdvertiserReview.pageTitle')}
        dashboardTitle={t('rm:offsiteAdvertiserReview.pageTitle')}
        showDatepicker={false}
        publisherId={publisherId}
      />

      <MainTabs />

      {/* Mesmo espaçamento do `CampaignFilters` da listagem principal */}
      <div className="d-flex gap-2 mb-2">
        <FilterCampaignStatus
          options={offsiteAdvertiserReviewStatusFilterOptions}
        />
      </div>

      <OffsiteAdvertiserReviewTable />
    </>
  )
}

export default OffsiteAdvertiserReviewList
